export { default } from './ColorPickerCDS';
